<template>
    <div class="Loading">
        <div v-show="loading.show && loading.bar" class="Loading__bar" :class="style"></div>
        <div class="Loading__box" :class="style">
            <div v-show="loading.icon" class="Loading__boxIcon">
                <i class="zmdi" :class="icon"></i>
            </div>
            <div class="Loading__boxMessage" v-html="loading.message"></div>
            <!--<button class="Loading__boxClose" aria-label="Fechar" @click="hide">-->
                <!--<i class="zmdi zmdi-close"></i>-->
            <!--</button>-->
        </div>
    </div>
</template>

<script>
    export default {
      created() {
        EventBus.$on('loading-show', this.show);
        EventBus.$on('loading-hide', this.hide);
      },
      computed: {
        loading() {
          return this.$store.state.loading;
        },
        style() {
          return {
            'is-hidden': !this.loading.show,
            'is-animated': true,
            'is-danger': this.loading.type === 'danger',
            'is-done': this.loading.type === 'done',
            'is-loading': this.loading.type === 'loading',
            'is-closing': this.loading.closing,
          }
        },
        icon() {
          return {
            'zmdi-close': this.loading.type === 'danger',
            'zmdi-check': this.loading.type === 'done',
          }
        }
      },
      methods: {
        hide(checkIfHasMessage = false) {
          this.$store.dispatch('hideLoading', checkIfHasMessage);
        },
        show(config = {}) {
          this.$store.dispatch('showLoading', config);
        }
      }
    }
</script>

<style lang="stylus">
    .Loading__box
        min-height 60px
        padding 0.5rem 1.5rem
        position fixed
        text-align center
        background #fff
        display flex
        align-items center
        z-index 10000
        font-size 14px
        left 50%
        top 2rem
        box-shadow 0 0 2px rgba(0,0,0,0.1), 0 3px 24px rgba(0,0,0,0.1)
        border-radius 4px
        font-weight 500
        line-height 1.4
        &.is-animated
            animation-name slideInTop
            animation-duration 0.2s
            animation-fill-mode both
        &.is-closing
            animation-name slideOutTop
            animation-duration 0.2s
            animation-fill-mode both
        &.is-hidden
            display: none!important
    .Loading__boxClose
        margin-left 0.5rem
        padding 0.5rem
        cursor pointer
        font-weight 600
        transition color 0.3s
        background none
        border none
        font-size 1.2rem
        margin-right -0.5rem
        text-transform uppercase
        color rgba(0, 0, 0, 0.3)
        &:hover
            color rgba(0, 0, 0, 0.5)
    .Loading__boxMessage
        color rgba(0, 0, 0, 0.6)
        flex-grow 1
        & > strong
            color rgb(255, 255, 255)
    .Loading__bar
        position fixed
        left 0
        top 0
        right 0
        width 100%
        height 2px
        /*background #f1d23a*/
        background #f1d23a
        z-index 10000
        animation shift-rightwards 1s ease-in-out infinite
        pointer-events none
        transform translateX(100%)
    .Loading__boxIcon
        display inline-flex
        justify-content center
        align-items center
        height 24px
        width 24px
        border-radius 100%
        margin-right 1rem
        background #f1d23a
        border 3px solid #f1d23a
        font-size 1rem
        color #fff
    .control > .Loading__boxIcon
    .Loading__box.is-loading > .Loading__boxIcon
        background none
        border-right-color transparent
        animation rotate-360 1s linear infinite
    .Loading__box.is-done
        background rgb(76, 175, 80)
        & > .Loading__boxMessage
            color #fff
    .Loading__box.is-danger
        background  rgb(244, 67, 54)
        & > .Loading__boxIcon
            background  rgb(244, 67, 54)
            border-color  rgb(244, 67, 54)
        & > .Loading__boxMessage
            color rgba(255, 255, 255, 0.9)
    .is-transitioning
        animation-duration 0.4s
        animation-fill-mode both

    @media screen and (min-width 540px)
        .Loading__box
            right auto
    @keyframes slideInTop
        0%
            transform translate3d(-50%, -300%, 0)
            visibility visible
        100%
            transform translate3d(-50%, 0, 0)
    @keyframes slideOutTop
        0%
            transform translate3d(-50%, 0, 0)
        100%
            transform translate3d(-50%, -300%, 0)

    @keyframes slideInBottom
        0%
            transform translate3d(0, 300%, 0)
            visibility visible
        100%
            transform translate3d(0, 0, 0)
    @keyframes slideOutBottom
        0%
            transform translate3d(0, 0, 0)
        100%
            transform translate3d(0, 300%, 0)
    @keyframes rotate-360
        to
            transform rotate(360deg)
    @keyframes shift-rightwards
        0%
            transform translateX(-100%)
        40%,
        60%
            transform translateX(0)
        to
            transform translateX(100%)
</style>
